import {enrollmentProviders} from '@/constants/enrollments.js'
import {useTeams} from '@/composables/use-teams.js'
import {computed} from 'vue'

/**
 * Provider detection composable
 * Determines the current provider (TEAMS vs WEB) based on context
 */
export function useProvider() {

  //Teams detection
  const {isInTeams} = useTeams()

  //Current provider based on Teams context
  const currentProvider = computed(() =>
    isInTeams.value ? enrollmentProviders.TEAMS : enrollmentProviders.WEB
  )

  //Expose interface
  return {
    currentProvider,
  }
}
